import PropTypes from 'prop-types'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import asyncComponent from '../HOC/asyncComponent'
import LoadingOverlay from '../LoadingOverlay'
import * as onboarding from './redux/store'
import * as site from '../../store/site'

const OnboardingModalAsync = asyncComponent(
  () => import('./components/OnboardingModal' /* webpackChunkName: "onboarding-modal" */),
  {loading: () => <LoadingOverlay />},
)

class OnboardingModalContainer extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    windowOnloadFired: PropTypes.bool.isRequired,
  }

  componentDidMount() {
    this.checkPreload()
  }

  componentDidUpdate() {
    this.checkPreload()
  }

  checkPreload() {
    // Preload should happen as early as possible, to minimize the chance of a delay when the user
    // invokes onboarding. But it shouldn't happen before the window onload event has fired, because
    // that would delay onload until after the preload has finished.
    if (this.props.windowOnloadFired) {
      OnboardingModalAsync.preload()
    }
  }

  render() {
    return this.props.isOpen && <OnboardingModalAsync />
  }
}

const mapStateToProps = createStructuredSelector({
  isOpen: onboarding.isOpen,
  windowOnloadFired: site.windowOnloadFired,
})

export default connect(mapStateToProps)(OnboardingModalContainer)
